export default __webpack_public_path__ + "static/media/4th.cd71eedd.png";